import pb from '../lib/pocketbase';

export async function getProyectos(page, perPage) {
  return await pb.collection('proyecto').getList(page, perPage, {
    sort: '-created', // Ordenar por fecha de creación descendente
    $autoCancel: false,
    expand: 'sucursal' // Expandir la relación con 'sucursal'
  });
}

export async function createProyecto(proyecto) {
  return await pb.collection('proyecto').create(proyecto);
}

export async function updateProyecto(id, proyecto) {
  return await pb.collection('proyecto').update(id, proyecto);
}

export async function deleteProyecto(id) {
  return await pb.collection('proyecto').delete(id);
}
